<template lang="pug">
  el-table(
    style="width: 100%;"
    header-cell-class-name='table-header'
    cell-class-name='pl-4'
    :data="notifications"
  )
    el-table-column(
      width="55"
    )
      template(slot-scope='scope')
        span.pre-line {{ scope.$index + 1}}
    el-table-column(
      prop="sensor_transmitter"
      :label="$t('notifications.label.sensor_transmitter')"
      width="150px"
      v-if="!isMobile"
    )
      template(slot-scope='scope')
        span {{ scope.row.sensor_transmitter.name }}
    el-table-column(
      prop="sensor_transmitter"
      :label="$t('notifications.label.soil_sensor')"
      width="140px"
      v-if="!isMobile"
    )
      template(slot-scope='scope')
        span {{ scope.row.soil_sensor.name }}
    el-table-column(
      prop="sensor_transmitter"
      :label="$t('notifications.label.sensor_transmitter')"
      width="120px"
      v-if="isMobile"
    )
      template(slot-scope='scope')
        span {{ scope.row.sensor_transmitter.name + " (" + scope.row.soil_sensor.name + ")" }}
    el-table-column(
      prop="message"
      :label="$t('notifications.label.message')"
      :width="isMobile ? '250px' : ''"
    )
      template(slot-scope='scope')
        span {{ scope.row.message }}
    el-table-column(
      prop="created_at"
      :label="$t('notifications.label.created_at')"
      :width="isMobile ? '100px' : '200px'"
    )
      template(slot-scope='scope')
        span(v-if='scope.row.created_at') {{ computeDate12HourFormat(scope.row.created_at) }}
        span(v-else) -
    el-table-column(
      prop="seen"
      :label="$t('notifications.label.seen')"
      :width="isMobile ? '80px' : '80px'"
    )
      template(slot-scope='scope')
        span(v-if='scope.row.seen') {{ '✔️' }}
        span(v-else) {{ '❗' }}
    el-table-column(
      prop="seen"
      :label="$t('notifications.label.actions')"
      :width="isMobile ? '170px' : '180px'"
    )
      template(slot-scope='scope')
        el-button.dark-green-btn.pop-up-btn(
          @click="handleAddNewSnoozeForNotification(scope.row)"
          :loading="loadingBtns"
          :disabled="scope.row.is_snooze_enabled"
          :class="{ faded: scope.row.is_snooze_enabled }"
          :title="scope.row.is_snooze_enabled? 'Snooze is already enabled for this data category': ''"
        ) {{ $t('notifications.actions.snooze') }}
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { filterUtils } from "@utils/filterUtils";
export default {
  name: 'NotificationsTable',
  mixins: [filterUtils],

  props: {
    notifications: {
      type: Array
    },

    isMobile: {
      type: Boolean,
      default: false
    },

    loadingBtns: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {

    }
  },
  created() {

  },
  methods: {

    ...mapMutations("dialog", [ "showAddSnoozeNotificationDialog" ]),
    ...mapMutations("notification", [ "setNotification" ]),

    handleAddNewSnoozeForNotification(notification){
      this.setNotification(notification);
      this.showAddSnoozeNotificationDialog();
    },
  }
}
</script>

<style scoped>
.faded {
  opacity: 0.5;
  /* pointer-events: none; */
}
</style>